import { useCallback, useState } from "react";


type CopyState = "copy" | "copied" | "error";


interface CopyResult {
    copyText: string;
    doCopy: () => void;
    copyState: CopyState;
    setCopyState: (copyState: CopyState) => void;
}


export function useCopy(
    value: string | null,
    copyText: string = "Copy",
    copiedText: string = "Copied",
    errorText: string = "Unable to Copy",
): CopyResult {
    const [state, setCopyState] = useState<CopyState>("copy");

    const doCopy = useCallback(() => {
        if (value === null)
            return;

        window.navigator.clipboard.writeText(value)
            .then(() => {
                setCopyState("copied");
            })
            .catch(() => {
                setCopyState("error");
            });
    }, [value, setCopyState]);

    return {
        copyText: (state === "copy" ? copyText : (state === "copied" ? copiedText : errorText)),
        doCopy,
        copyState: state,
        setCopyState,
    };
}
